import React, { useMemo } from "react";
import moment from "moment";
import { useTranslation } from "react-i18next";

const KEYS_SUN_FIRST = ["sun", "mon", "tue", "wed", "thu", "fri", "sat"];
const momentWeekdayIndex = { mon: 1, tue: 2, wed: 3, thu: 4, fri: 5, sat: 6, sun: 0 };

const getOrderedDayKeys = (startingCalendarDay) => {
  const start = ((Number(startingCalendarDay) || 0) % 7 + 7) % 7;
  const keys = [...KEYS_SUN_FIRST];
  while (momentWeekdayIndex[keys[0]] < start) {
    keys.push(keys.shift());
  }
  return keys;
};

const SelectDays = ({ days, setDays, startingCalendarDay = 0 }) => {
  const { i18n } = useTranslation();
  const orderedDayKeys = useMemo(
    () => getOrderedDayKeys(startingCalendarDay),
    [startingCalendarDay],
  );
  const labelByKey = useMemo(() => {
    const lang = (i18n.language || "en").split("-")[0];
    const localeData = moment.localeData(lang);
    const mins = localeData.weekdaysMin();
    const out = {};
    for (const key of KEYS_SUN_FIRST) {
      const min = mins[momentWeekdayIndex[key]];
      out[key] = min.slice(0, 1).toLocaleUpperCase(lang);
    }
    return out;
  }, [i18n.language]);

  return (
    <div className="accountability-days">
      {orderedDayKeys?.map((day) => (
        <div
          className={
            days[day] ? "p4 accountability-day active" : "p4 accountability-day"
          }
          onClick={() => {
            setDays ? setDays(day) : null;
          }}
          key={day}
        >
          {labelByKey[day]}
        </div>
      ))}
    </div>
  );
};

export default SelectDays;
